import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import { fetchMe } from "./features/auth/authSlice";
import VersionGate from "./components/common/VersionGate";

export default function App() {
  const dispatch = useDispatch();
  const { accessToken, user } = useSelector((s) => s.auth);

  useEffect(() => {
    if (accessToken && !user) {
      dispatch(fetchMe());
    }
  }, [accessToken, user, dispatch]);

  return (
    <VersionGate>
      <AppRoutes />
    </VersionGate>
  );
}
